<template>
  <div class="fab-container" :style="containerStyle">
    <div class="fab-container-button" @click="handelClick">
      <div class="share-Icon">
        <span class="iconfont icon-share"></span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import useClipboard from 'vue-clipboard3';
import { message } from 'ant-design-vue';
const props = defineProps({
  // 距离右侧距离
  right: {
    type: Number,
    default: 24
  },
  // 距离底部距离
  bottom: {
    type: Number,
    default: 24
  },
  // 按钮大小
  size: {
    type: String,
    default: 'large',
    validator: (value) => ['small', 'middle', 'large'].includes(value)
  },
  // 图标类型
  icon: {
    type: String,
    default: 'plus'
  },
  // 悬浮提示文字
  tooltip: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['handelClick']);
const { toClipboard } = useClipboard();
const router = useRouter()
const route = useRoute()

const url = computed(() => {
  return `${location.origin}#${route.fullPath}`
})

const copy = async () => {
  try {
    await toClipboard(url.value);
    message.success('复制成功');
  } catch (e) {
    message.error(`复制失败: ${e}`);
  }
};


const containerStyle = computed(() => ({
  right: `${props.right}px`,
  bottom: `${props.bottom}px`
}));

const handelClick = () => {
  emit("handelClick")
}


onMounted(() => {

});
</script>

<style scoped lang="less">
.fab-container {
  position: fixed;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fab-button {
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.fab-button:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.16),
    0 9px 28px 0 rgba(0, 0, 0, 0.12),
    0 12px 48px 16px rgba(0, 0, 0, 0.09);
}

.fab-button:active {
  transform: scale(0.98);
}

.fab-container-button {
  cursor: pointer;
}

.fab-popover-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 5px;
  padding: 10px;
}

.fab-popover-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.fab-popover-item-img {
  width: 30px;
  height: 30px;
}

.qr-code {
  width: 120px;
  height: 120px;
}

.share-Icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 26px;
  }
}

.share-Icon:hover {
  background: #f5f5f5;
}
</style>
